import React, { useEffect } from "react";
import "./newtrainer.css";
import { Form, Input, Button, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  changeTrainerModalState,
  createOrUpdateTrainer,
  fetchTrainerTableData,
} from "../../../features/adminAsync";
import Alert from "../../../components/common/alert";
import { subjects } from "../../common/constants";

const { Option } = Select;

const NewTrainer = ({ trainerId, actionType }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { trainerdetails } = useSelector((state) => state.admin);

  useEffect(() => {
    if (trainerId && trainerdetails) {
      form.setFieldsValue({
        name: trainerdetails.name || "",
        emailid: trainerdetails.emailid || "",
        contact: trainerdetails.contact || "",
        prefix:  "+65",
        subject: trainerdetails.subject || "",
      });
    } else {
      form.resetFields(); // Reset form when adding new trainer
    }
  }, [trainerId, trainerdetails, form]);

  const handleSubmit = (values) => {
    const payload = {
      name: values.name,
      password: values.password,
      emailid: values.emailid,
      contact: values.prefix + values.contact,
      subject: values.subject,
    };

    if (trainerId) {
      payload._id = trainerId; // Only send _id on update
    }

    console.log("Payload submitting:", payload);

    dispatch(createOrUpdateTrainer({ payload, isEdit: Boolean(trainerId) }))
      .unwrap()
      .then((result) => {
        Alert("success", "Success", result.message);
        form.resetFields();
        dispatch(
          changeTrainerModalState({
            showModal: false,
            trainerId: null,
            actionType: "Register",
          })
        );
        dispatch(fetchTrainerTableData());
      })
      .catch((err) => {
        const errorMessage = err?.message || "Something went wrong.";
        Alert("error", "Error!", errorMessage);
      });
  };

  return (
    <div className="register-trainer-form">
      <div className="register-trainer-form-body">
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          initialValues={{ prefix: "+65" }}
        >
          <Form.Item
            label="Subject"
            name="subject"
            rules={[{ required: true, message: "Please select a subject!" }]}
          >
            <Select placeholder="Select a subject">
              {subjects.map((d) => (
                <Option key={d._id} value={d.value}>
                  {d.value}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Name"
            name="name"
            rules={[
              { required: true, message: "Please input your name!" },
              { whitespace: true },
            ]}
          >
            <Input />
          </Form.Item>

          {!trainerId && (
            <Form.Item
              label="E-mail"
              name="emailid"
              rules={[
                { type: "email", message: "The input is not a valid E-mail!" },
                { required: true, message: "Please input your E-mail!" },
              ]}
            >
              <Input />
            </Form.Item>
          )}

          <Form.Item
            label="Phone Number"
            name="contact"
            rules={[
              { required: true, message: "Please input your phone number!" },
              { len: 8, message: "Contact number must be 8 digits long" },
            ]}
          >
            <Input
              addonBefore={
                <Form.Item name="prefix" noStyle>
                  <Select style={{ width: 70 }}>
                    <Option value="+65">+65</Option>
                  </Select>
                </Form.Item>
              }
            />
          </Form.Item>

          {!trainerId && (
            <>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
                hasFeedback
              >
                <Input.Password />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="confirm"
                dependencies={["password"]}
                hasFeedback
                rules={[
                  { required: true, message: "Please confirm your password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match!")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
            </>
          )}

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {actionType}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default NewTrainer;
